<template>
  <div class="animated fadeIn step-container plan-payment">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="text-center">สมัครแพลนการใช้งาน</h2>
      </div>
      <div class="col-md-8 offset-md-2">
        <step :currentStep="2" :maxStep="3" @step_clicked='gotoPage'>
          <div slot='1'>กรอกรายละเอียด</div>
          <div slot='2'>การชำระเงิน</div>
          <div slot='3'>ยืนยัน</div>
        </step>
      </div>
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">วิธีการชำระเงิน</h4>
        <div class="row">
          <div class="col-sm-6 payment-creditcard">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="ccnumber">Credit Card Number <i class="fa fa-credit-card" aria-hidden="true"></i></label>
                  <input type="text" class="form-control" id="ccnumber" placeholder="4242 4242 4242 4242" maxlength="16" v-model="creditCardDetail.number" v-validate="'required|digits:16'" name="ccnumber" :class="{'is-invalid': errors.has('ccnumber') }">
                  
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <label for="ccmonth">Month</label>
                <select class="form-control" id="ccmonth" v-model="creditCardDetail.expiration_month" v-validate="'required'" name="ccmonth" :class="{'is-invalid': errors.has('ccmonth') }">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                  <option>11</option>
                  <option>12</option>
                </select>
              </div>
              <div class="form-group col-4">
                <label for="ccyear">Year</label>
                <select class="form-control" id="ccyear" v-model="creditCardDetail.expiration_year" v-validate="'required'" name="ccyear" :class="{'is-invalid': errors.has('ccyear') }">
                  <option v-for="year in years">{{year}}</option>
                </select>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="cvv">CVV/CVC</label>
                  <input type="text" class="form-control" id="cvv" placeholder="123" v-model="creditCardDetail.security_code" maxlength="3" v-validate="'required|digits:3'" name="cvv" :class="{'is-invalid': errors.has('cvv') }">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right payment-gateway">
                <span>Supported by </span><img src="/static/img/plans/omise.svg">
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="form-group col-sm-12">
                <label for="name">Name</label>
                <input type="text" class="form-control" id="fullname" placeholder="Fullname" v-model="creditCardDetail.name" name="name" v-validate="'required'" :class="{'is-invalid': errors.has('name') }">
              </div>

              <div class="form-group col-sm-8">
                <label for="city">City</label>
                <input type="text" class="form-control" placeholder="Enter your city" v-model="creditCardDetail.city" name="city" v-validate="'required'" :class="{'is-invalid': errors.has('city') }">
              </div>

              <div class="form-group col-sm-4">
                <label for="postal-code">Postal Code</label>
                <input type="text" class="form-control" placeholder="Postal Code" v-model="creditCardDetail.postal_code" name="postalCode" v-validate="'required'" :class="{'is-invalid': errors.has('postalCode') }">
              </div>
            </div>
          </div>
        </div>

        
        
        <div class="row payment-footer">
          <div class="col-4 form-group text-left">
            <router-link class="btn btn-link btn-lg" :to="backLink + addAppParams"><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i> {{$t('action_message.back')}}</router-link>
          </div>
          <div class="col-4 text-center">
            <div class="total-price-box">
              <p class="total-price-title">ยอดรวม</p>
              <p class="total-price-amount"><strong>฿{{selectedPlan.price + creditCardFee | formatNumber}}</strong></p>
            </div>
          </div>
          <div class="col-4 form-group text-right">
            <button class="btn btn-store btn-lg" style="cursor: pointer" @click="submitAndNext()" :disabled="isLoading"><i class="fa fa-spinner fa-spin fa-fw" v-if="isLoading"></i> ต่อไป <i class="fa fa-angle-right" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div>
    <sweet-modal icon="error" title="Please check payment detail" ref="errorModal" overlay-theme="dark">
      Please check your payment detail
      <button slot="button" class="btn btn-store btn-lg" @click="closeModal()">Ok</button>
    </sweet-modal>
  </div>
</template>

<script>
import Step from '@/components/StepBar'
import moment from 'moment'
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    Step,
    SweetModal
  },
  data () {
    return {
      isLoading: false,
      creditCardDetail: {},
      err: {},
      selectedPlan: {},
      plans: [
        {
          id: 1,
          name: 'Basic Plan (subscription)',
          detail: '499 (per month) x 3 months',
          duration: '3 เดือน',
          price: 1497
        },
        {
          id: 2,
          name: 'Advance Plan (subscription)',
          detail: '฿399 (per month) x 12 months',
          duration: '1 ปี',
          price: 4788
        },
        {
          id: 3,
          name: 'Pro Plan (subscription)',
          detail: '฿299 (per month) x 36 months',
          duration: '3 ปี',
          price: 10764
        }
      ]
    }
  },
  computed: {
    backLink () {
      return '/package/payment/step1?plan_id=' + this.selectedPlan.id
    },
    nextLink () {
      return '/package/payment/step3?plan_id=' + this.selectedPlan.id
    },
    addAppParams () {
      if (this.$route.query.app !== null && this.$route.query.app !== undefined) {
        return '&app=' + this.$route.query.app
      }
      return ''
    },
    years () {
      let time = moment()
      let years = []
      for (let i = 0; i < 20; i++) {
        years.push(time.year())
        time.add(1, 'y')
      }
      return years
    },
    creditCardFee () {
      if (typeof this.selectedPlan.price === 'undefined') {
        return 0
      }
      return parseInt(this.selectedPlan.price * 0.038)
    }
  },
  mounted () {
    if (this.$route.query.plan_id &&
    this.$route.query.plan_id > 0 &&
    this.$route.query.plan_id <= 3) {
      this.selectedPlan = this.plans[parseInt(this.$route.query.plan_id) - 1]
    } else {
      this.selectedPlan = this.plans[0]
    }
    this.creditCardDetail = Object.assign({}, this.$ls.get('creditCardDetail'))
  },
  methods: {
    gotoPage (step) {
      this.$router.push({path: `/package/payment/step${step + 1}?plan_id=${this.selectedPlan.id}`})
    },
    submitAndNext () {
      this.validate()
      .then(result => {
        this.isLoading = true
        return this.$http.post(this.$APP_CONFIG.api.admin.payment_token(), this.creditCardDetail)
      })
      .then(resp => {
        // payment_token expired in 1 hours
        this.$ls.set('paymentToken', resp.body.id, 60 * 60 * 1000)
        this.$ls.set('creditCardDetail', this.creditCardDetail, 5 * 60 * 1000)
        this.$router.push({path: '/package/payment/step3?plan_id=' + this.selectedPlan.id + this.addAppParams})
      }).catch(err => {
        this.isLoading = false
        console.log(err)
        this.$refs.errorModal.open()
      })
    },
    closeModal () {
      this.$refs.errorModal.close()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            resolve(result)
          } else {
            reject(new Error('Not validated'))
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang='scss'>
@import "../../../assets/base_container";
.plan-payment{
  table{
    border-bottom: 1px #cfd8dc solid;
  }
  .payment-gateway{
    img{
      width: 70px;
    }
    span{
      padding-right: 10px;
    }
  }
  .payment-creditcard{
    border-right: 1px #ddd solid;
  }
  .total-price-box{
    border: 1px #aaa solid;
    display: inline-block;
    padding: 5px;
    background-color: #eee;
    p{
      margin: 0px;
    }
    .total-price-amount{
      font-size: 24px;
    }
    .total-price-title{
      border-bottom: 1px solid #aaa;
    }
  }
  .payment-footer{
    margin-top: 40px;
    margin-bottom: 20px;
    .btn{
      margin-top: 25px;
    }
  }
}
.step-body{
  background-color: #fff;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// step2.vue?3e9cbd8a